import React, { Component } from 'react';
import Input from './Input.js';
import SelectBox from './Select.js';
import Select from 'react-select';
import Validation from '../container/Validation.js';
import PropTypes from 'prop-types';
import Searchable from './Searchable.js';

export default class InputSelect extends Component{
	constructor(props){
		super(props);
		this.state ={
			to:'Select',
			from:'Select',
			for:'',
			value:'Select',
			date:'',
			valid:false,
			notValid:'',
			searchToVal:'',
			searchFromVal:''
		};
		this.handleInput = this.handleInput.bind(this);
		this.handleDate = this.handleDate.bind(this);
		this.handleToSearch = this.handleToSearch.bind(this);
		this.handleToSelect = this.handleToSelect.bind(this);
		this.handleFromSearch = this.handleFromSearch.bind(this);
		this.handleFromSelect = this.handleFromSelect.bind(this);
		//this.handleSearch = this.handleSearch.bind(this);
	}

	handleDate(identity,value){ //method for handling date input 
		const theState = {};
		if(/^(\s*|[0-9/-]*)$/g.test(value)){ //only allow blank space or numbers, slashes and dashes
			theState[identity] = value;
			this.setState(theState);
		}
	}

	handleInput(identity,value){ //standard method for handling input
		const theState = {};
		theState[identity] = value;
		this.setState(theState);
	}

	handleToSearch(value){ 
		this.setState({searchToVal: value});
	}

	handleToSelect(value){
		this.setState({to: value, searchToVal: value});
	}

	handleFromSelect(value){
		this.setState({from: value, searchFromVal: value});
	}

	handleFromSearch(value){
		this.setState({searchFromVal: value});
	}

	componentDidUpdate(prevProps,prevState){
		let s = this.state;
		if (this.props.submit !== prevProps.submit && this.props.submit){ //if submit has been clicked, continue
			let reason = '';
			if(s.to !== "Select" && s.from !== "Select" && s.for.trim() !== "" && s.value !== "Select" && s.date.trim() !== ""){ //make sure all fields are filled out 
				if(s.for.trim() !== ""){
					reason = s.for.replace(/(<([^>]+)>)/ig,"");//replace special characters
				}
				if(reason.trim()!== ""){
					reason = reason.replace(/\*/g,"");//replace asterisk
				}
				if(reason.trim() !== ""){
					reason = reason.replace(/\=/g,"");//replace assignment operator
				}
				this.props.onChange({complete:true,to:s.to,from:s.from,for:reason.trim(),value:s.value,date:s.date.trim()}); //pass up sanitized data

			}else if(s.to !== "Select" || s.from !== "Select" || s.for.trim() !== "" || s.value !== "Select" || s.date.trim() !== ""){

				this.props.onChange({complete:false,to:s.to,from:s.from,for:s.for.trim(),value:s.value,date:s.date.trim()});//if one or more field is empty but others are filled out, pass values up with complete flag set to false
			}
			this.setState({to:'Select',from:'Select',for:'',value:'Select',date:'',searchToVal:'',searchFromVal:''}); //clear inputs and reset dropdown menus
		}
	}

	render(){
		const searchableStyles = {
			input:{
				borderWidth: '.125rem',
				borderRadius: '3px 3px 3px 3px',
				borderColor: 'gray',
				height: '2rem',
				width: '100%',
				paddingLeft: '10px',
				boxShadow: '0 0 8px 2px rgba( 0, 0, 0, .2 )'
			},
			list:{
				listStyleType:'none',
				backgroundColor: 'white',
				width: '100%',
				maxHeight: '200px',
				overflowY: 'auto',
				margin: '0',
				paddingLeft: '0'
			}
		};
		let dateStyles = "h2 pa2 br2 bw1 w-100 shadow-2";
		let forStyles = "h2 pa2 br2 bw1 w-100 shadow-2";
		let employeeOptions = this.props.employees.map((employee,i)=>{ //get all employee names
			return (employee.value);
		});
		if(this.state.date !== '' && !Validation("date",this.state.date)){ //highlight date input field if not empty and not a valid date format
			dateStyles = "h2 pa2 br2 bw1 w-100 b--red shadow-2";
		}
		const selectStyles = "h2 pa1 w-100 br2 bw1 truncate shadow-2";
		const tdStyle = "pa2 w-20 relative";
		let options = this.props.virtues;
		const to_container_id = "to_combo_box_container_"+this.props.prefix;
		const to_input_id = "to_combo_box_"+this.props.prefix;
		const from_container_id = "from_combo_box_container_"+this.props.prefix;;
		const from_input_id = "from_combo_box_"+this.props.prefix;
		return(
			<tr>
				<td className={tdStyle}>
					<Searchable
						containerId={to_container_id}
						inputId={to_input_id}
						placeholder="Search or Select"
						style={searchableStyles}
						listItemClass="search_list_item"
						caseSensitive={false}
						value={this.state.searchToVal}
						options={employeeOptions}
						handleSelect={this.handleToSelect}
						handleChange={this.handleToSearch}
					/>
				</td>
				<td className={tdStyle}>
					<Searchable
						containerId={from_container_id}
						inputId={from_input_id}
						placeholder="Search or Select"
						style={searchableStyles}
						listItemClass="search_list_item"
						caseSensitive={false}
						value={this.state.searchFromVal}
						options={employeeOptions}
						handleSelect={this.handleFromSelect}
						handleChange={this.handleFromSearch}
					/>
				</td>
				<td className={tdStyle}><Input identity="for"  onInput={this.handleInput} inputStyle={forStyles} val={this.state.for}/></td>
				<td className={tdStyle}><SelectBox identity="value" options={options} onSelect={this.handleInput} styles={selectStyles} val={this.state.value}/></td>
				<td className={tdStyle}><Input identity="date" placeholder="mm/dd/yyyy"  onInput={this.handleDate} inputStyle={dateStyles} val={this.state.date}/></td>
			</tr>

		);
	}
}

InputSelect.propTypes = {
	employees: PropTypes.array.isRequired,
	virtues: PropTypes.array.isRequired,
	submit: PropTypes.bool.isRequired
};

//<SelectBox identity="to" onSelect={this.handleInput} options={employeeOptions} styles={selectStyles} val={this.state.to}/>


// WEBPACK FOOTER //
// ./src/component/InputSelect.js